type TLanguage = 'EN' | 'SE';
interface ILanguageData {
  [key: string]: string;
}

export const useLanguage = (lang: TLanguage) => (obj: ILanguageData): string =>
  obj[lang] || '';
